import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Home, BarChart3, ShoppingCart, User } from "lucide-react";

export default function MobileLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: "Home", icon: Home, path: "/m-home" },
    { label: "Analytics", icon: BarChart3, path: "/m-analytics" },
    { label: "Sales", icon: ShoppingCart, path: "/m-sales" },
    { label: "Profile", icon: User, path: "/m-profile" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-[#f4f7fb] flex flex-col">

      {/* PAGE CONTENT */}
      <div className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </div>

      {/* BOTTOM NAV (GLOBAL MOBILE) */}
      <div className="fixed bottom-3 left-3 right-3 z-50">
        <div className="bg-white/90 backdrop-blur-lg border shadow-xl rounded-2xl px-2 py-2 flex justify-around">

          {navItems.map((item, i) => {
            const Icon = item.icon;
            const active = isActive(item.path);

            return (
              <button
                key={i}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center justify-center w-full relative py-1"
              >
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-xl
                  ${active ? "bg-indigo-100 text-indigo-600" : "text-gray-400"}`}
                >
                  <Icon size={18} />
                </div>

                <span
                  className={`text-[10px] mt-1
                  ${active ? "text-indigo-600 font-semibold" : "text-gray-400"}`}
                >
                  {item.label}
                </span>
              </button>
            );
          })}

        </div>
      </div>
    </div>
  );
}